import { ImageMapper } from "src/common/assets/images";
import variables from "src/common/assets/variables";

const getImageTint = (status) => {
  switch (status) {
    case 10: //payment pending
      return variables.$priceColor;
    case 9: //pending
      return variables.$brandColor;
    case 8: //cancelled
      return variables.$danger;
    case 3: //MERCHANT_COMPLETED
      return "#FACE5F";
    case 11: //payment failed
      return variables.$danger;
    default:
      return variables.$brandColor;
  }
};

const getOrderStatusImage = (status) => {
  switch (status) {
    case 10: //payment pending
      return ImageMapper.CheckOrange;
    //todo
    case 8: //cancelled
      return ImageMapper.CheckOrange;
    case 11: //failed
      return ImageMapper.Stop;
    default:
      return ImageMapper.CheckBlue;
  }
};

const getOrderStatusColor = (status) => {
  switch (status) {
    case 10: //payment pending
      return variables.$priceColor;
    //todo
    case 9: //pending
      return variables.$brandColor;
    case 8: //cancelled
      return variables.$danger;
    case 7: //complete
      return variables.$priceColor;
    case 3: //MERCHANT_COMPLETED
      return "#FACE5F";
    case 11: //payment failed
      return variables.$danger;
    default:
      return variables.$brandColor;
  }
};

enum ORDER_STATUS {
  STARTED = 1,
  MERCHANT_ACCEPTED = 2,
  MERCHANT_COMPLETED = 3,
  IN_COLLECTION = 4,
  AT_HUB = 5,
  IN_TRANSIT = 6,
  COMPLETED = 7,
  CANCELED = 8,
  PENDING = 9,
  PAYMENT_PENDING = 10,
  PAYMENT_FAILED = 11,
  REFUNDED = 12
}

export { getOrderStatusImage, getOrderStatusColor, getImageTint, ORDER_STATUS };
